import React from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import type { Comissao } from "src/@types/Home";
import { formatMoney } from "@helpers/format";

interface ICustomComitions {
  showValues: boolean;
  setShowValues: React.Dispatch<React.SetStateAction<boolean>>;
  data: Comissao[];
}

const CustomComitions: React.FC<ICustomComitions> = React.memo(
  ({ data, showValues, setShowValues }) => {
    const isMobile = useBreakpointValue({ base: true, md: false });

    const toggleValues = React.useCallback(() => {
      setShowValues((prev) => !prev);
    }, [setShowValues]);

    const memoizedData = React.useMemo(() => data || [], [data]);

    if (isMobile) {
      return (
        <Box>
          {memoizedData.map((item, index) => (
            <Box
              key={index}
              p={3}
              mb={2}
              borderWidth="1px"
              borderRadius="md"
              bg="gray.50"
            >
              <Flex justify="space-between" mb={1}>
                <Box fontSize="xs" color="gray.600">
                  Status:
                </Box>
                <Box fontSize="xs">{item.statusPagamento}</Box>
              </Flex>
              <Flex justify="space-between" mb={1}>
                <Box fontSize="xs" color="gray.600">
                  Oportunidade:
                </Box>
                <Box fontSize="xs">{item.idOportunidade}</Box>
              </Flex>
              <Flex justify="space-between" mb={1}>
                <Box fontSize="xs" color="gray.600">
                  Cliente:
                </Box>
                <Box fontSize="xs">{item.cliente}</Box>
              </Flex>
              <Flex justify="space-between" mb={1}>
                <Box fontSize="xs" color="gray.600">
                  Data:
                </Box>
                <Box fontSize="xs">{item.dataDePagamento}</Box>
              </Flex>
              <Flex justify="space-between" align="center">
                <Box fontSize="xs" color="gray.600">
                  Valor:
                </Box>
                <Flex align="center" gap={2}>
                  <Box fontSize="xs">
                    {showValues
                      ? `${formatMoney(item.valorHonorarios)}`
                      : "R$ •••••"}
                  </Box>
                  <Box cursor="pointer" onClick={toggleValues} fontSize="14px">
                    {showValues ? <FaRegEye /> : <FaRegEyeSlash />}
                  </Box>
                </Flex>
              </Flex>
            </Box>
          ))}
        </Box>
      );
    }

    return (
      <Box>
      <Table variant="simple">
          <Thead
            h="60px"
            position="sticky"
            top="0"
            zIndex="1"
            bg="white"
            boxShadow="sm"
          >
            <Tr>
            <Th width="20%">Status</Th>
            <Th width="20%">Oportunidade</Th>
            <Th width="20%">Cliente</Th>
            <Th width="20%">Data prevista</Th>
              <Th isNumeric textAlign="center">
              <Flex gap="4px" align="center" justify={"center"} h={"fit-content"}>
                Valor{" "}
                  <Box
                    cursor="pointer"
                    onClick={toggleValues}
                    fontSize="17px"
                    w={"fit-content"}
                  >
                    {showValues ? <FaRegEye /> : <FaRegEyeSlash />}
                  </Box>
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {memoizedData.map((item, index) => (
              <Tr key={index}>
                <Td width="20%" fontSize="12px">
                  {item.statusPagamento}
                </Td>
                <Td width="20%" fontSize="12px">
                  {item.idOportunidade}
                </Td>
                <Td width="20%" fontSize="12px">
                  {item.cliente}
                </Td>
                <Td width="20%" fontSize="12px">
                  {item.dataDePagamento}
                </Td>
                <Td width="20%" fontSize="12px" isNumeric>
                  {showValues
                    ? `${formatMoney(item.valorHonorarios)}`
                    : "R$ •••••"}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    );
  }
);

export default CustomComitions;
